import {
  FC_PAYMENT_FETCH_SUCCESS,
} from '../actionTypes';

let initialState = {}

export default function fc_payment(state = initialState, action) {
  switch(action.type) {
    case FC_PAYMENT_FETCH_SUCCESS:
      return {...state, ...action.payload};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/CreditLimit/reducers/fc_payment.js